import { render } from "./AppPrimary.vue?vue&type=template&id=791c96d6"
import script from "./AppPrimary.vue?vue&type=script&lang=js"
export * from "./AppPrimary.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__